module.exports = __webpack_public_path__ + "static/media/side_menu_logo.25a06980.svg";